module.exports = __webpack_public_path__ + "img/music.e3e14ac9.svg";